import PropTypes from 'prop-types';
import TabType from './tab-type';
var PanelType = {
  tab: PropTypes.shape(TabType).isRequired,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};
export default PanelType;